export default __webpack_public_path__ + "static/media/EAS_03.68bedcd2.jpg";